module.exports = __webpack_public_path__ + "static/media/image.1c8ba196.png";